import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  Text,
  Flex,
  Link,
} from '@chakra-ui/react';
import Button from 'common/components/button';
import { useState } from 'react';

const UnitLayoutHelperModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size='xl'>
      <ModalOverlay />
      <ModalContent className='rounded-lg'>
        <ModalHeader className='text-xl font-medium border-b border-gray-200'>
          How ReLease works with Roommates
        </ModalHeader>
        <ModalBody className='pt-4 pb-6'>
          <Flex className='flex-col gap-4 text-gray-500'>
            <Text className='text-base'>
              Your ReLease plan covers your lease and all persons listed on the agreement. If you file a claim to move out early, your lease contract will be terminated and all persons listed on your lease must vacate the unit.
            </Text>
            <Text className='text-base'>
              Here are a few examples for how ReLease works with roommates:
            </Text>
            <Text className='text-base'>
              <span className='font-medium text-black'>Example A:</span> if you are renting a 3-bedroom unit with two roommates, and you are all listed on the same lease agreement, you must all vacate the unit if a claim is filed to terminate your lease agreement.
            </Text>
            <Text className='text-base'>
              <span className='font-medium text-black'>Example B:</span> If you are renting one bedroom in a suite with three bedrooms, and all tenants have separate lease agreements, only you will need to vacate your unit if you terminate your lease agreement early with ReLease.
            </Text>
            <Text className='text-base'>
              Please select the unit layout for your entire apartment/unit (not just your individual bedroom)
            </Text>
          </Flex>
        </ModalBody>
        <ModalFooter className='border-t border-gray-200'>
          <ButtonGroup>
            <Button title='I Understand' onClick={onClose} wFull={false} />
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const UnitLayoutHelperLink = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Link
        onClick={() => setIsOpen(true)}
        className='underline cursor-pointer'
      >
        {children || 'Not sure or have roommates?'}
      </Link>
      <UnitLayoutHelperModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export { UnitLayoutHelperModal, UnitLayoutHelperLink }; 